import { render, staticRenderFns } from "./comercializaciondigital.vue?vue&type=template&id=7f0e77b3&"
import script from "./comercializaciondigital.vue?vue&type=script&lang=js&"
export * from "./comercializaciondigital.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports